module.exports = require('./lib/i18n');
